import { type FC } from "react";
import { PageContext, PageOptions } from "../../types/page";
import ArrowLeftIcon from "../../components/icons/ArrowLeftIcon";
import ChatForm from "./components/ChatForm";
import Navbar from "../../components/Navbar";
import { Slot, Templated } from "../../templating";

interface CustomerInquiryPageProps {
  navigate: (pageOptions: PageOptions) => void;
  isFullscreen: boolean;
}

const CustomerInquiryPage: FC<CustomerInquiryPageProps> = ({ navigate, isFullscreen }) => {
  const handleSubmit = async (pageContext: PageContext): Promise<void> => {
    navigate({ page: { type: "conversation" }, pageContext });
  };

  return (
    <Templated id="lastbot-customer-inquiry-page">
      <>
        <Slot name="navbar">
          <Navbar bordered={false} isFullscreen={isFullscreen}>
            <button
              type="button"
              onClick={() => navigate({ page: { type: "landing" } })}
              className="-ml-1 text-lastbot-icon-muted cursor-pointer"
              data-testid="back-button"
            >
              <ArrowLeftIcon />
            </button>
          </Navbar>
        </Slot>
        <Slot name="composer-text">
          <ChatForm onSubmit={handleSubmit} />
        </Slot>
      </>
    </Templated>
  );
};

export default CustomerInquiryPage;
